import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function CitiesCard() {
  const [citiesCount, setCitiesCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCities() {
      try {
        const snap = await getDocs(collection(db, "users"));

        const citySet = new Set();

        snap.forEach((doc) => {
          const city = (doc.data().city || "").trim();
          if (city.length > 0) {
            citySet.add(city);
          }
        });

        setCitiesCount(citySet.size);
      } catch (error) {
        console.error("Erro ao carregar cidades:", error);
      } finally {
        setLoading(false);
      }
    }

    loadCities();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Cidades alcançadas</p>

      <p className="metric-value">
        {loading || citiesCount === null ? "..." : citiesCount.toLocaleString("pt-BR")}
      </p>

      <span className="metric-tag">Distribuição nacional</span>
    </div>
  );
}
